import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline',
    minWidth: 0,
    padding: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('xs')]: {
      paddingTop: ({ hasTopPadding }) => (hasTopPadding ? '15px' : 0),
      paddingBottom: '7px',
      paddingLeft: 0,
      paddingRight: 0,
      textTransform: 'none',
      borderRadius: 0
    }
  }
}));

const MenuSectionsBarNavLink = ({
  highlighted,
  fullWidth,
  dataTestId,
  children,
  hasBottomPadding,
  hasTopPadding
}) => {
  const classes = useStyles({ highlighted, hasBottomPadding, hasTopPadding });
  return (
    <Button
      fullWidth={fullWidth}
      classes={classes}
      variant="text"
      data-testid={dataTestId}
    >
      {children}
    </Button>
  );
};

MenuSectionsBarNavLink.defaultProps = {
  fullWidth: false
};
MenuSectionsBarNavLink.propTypes = {
  highlighted: PropTypes.bool,
  fullWidth: PropTypes.bool,
  classes: PropTypes.shape({}),
  dataTestId: PropTypes.string,
  children: PropTypes.node,
  hasBottomPadding: PropTypes.bool,
  hasTopPadding: PropTypes.bool
};

export default MenuSectionsBarNavLink;
